import React from 'react';
import { Button, Typography, Card } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const SessionExpired: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Card style={{ maxWidth: 480, padding: 32 }}>
        <Title level={3}>Session Expired</Title>
        <Paragraph>
          You have been logged in on another device.<br />
          Please log in again.
        </Paragraph>
        <Button type="primary" onClick={() => navigate('/login')}>Login</Button>
      </Card>
    </div>
  );
};

export default SessionExpired;
